"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderDetails = void 0;
const react_1 = require("react");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const utils_1 = require("../utils");
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
/** 活跃仓位详情 */
const useOrderDetails = (id, data) => {
    var _a;
    const [state, setState] = (0, react_1.useState)({
        data,
    });
    const dataRef = (0, react_1.useRef)();
    dataRef.current = state.data;
    /** 需要请求数据：没有传入完整数据，但是有传入 id */
    const needFetchOrder = Boolean(!(data === null || data === void 0 ? void 0 : data.bu_order_id) && id);
    const refreshData = (0, react_1.useCallback)(() => {
        if (needFetchOrder) {
            setState({
                isLoading: true,
            });
            SimpleFuturesAPI_1.SimpleFuturesAPI.getOrder({ bu_order_id: id }).subscribe({
                next: (res) => {
                    const newData = utils_1.SimpleFuturesUtils.transferOrderAPIToUI(res);
                    setState({
                        data: newData,
                    });
                },
                error: (err) => {
                    setState({
                        error: err,
                    });
                },
            });
        }
    }, [id, needFetchOrder]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (((_a = state.data) === null || _a === void 0 ? void 0 : _a.status) !== "open") {
            return;
        }
        // 监听活跃仓位 wss
        const ssOb$ = (0, trade_utils_lib_1.getTradeDependencyInstance)().getAccountWebSocket().getAllDataObservable();
        const wssSub = ssOb$
            .pipe((0, operators_1.filter)((wssRes) => {
            const wssData = wssRes === null || wssRes === void 0 ? void 0 : wssRes.data;
            const isFutureLiteBu = (wssRes === null || wssRes === void 0 ? void 0 : wssRes.channel) === "bu_order" && (wssData === null || wssData === void 0 ? void 0 : wssData.bu_order_type) === "futures_lite";
            if (!isFutureLiteBu || !dataRef.current) {
                return false;
            }
            const isCurrentOrder = wssData.bu_order_id === dataRef.current.bu_order_id;
            return isCurrentOrder;
        }), (0, operators_1.map)((res) => utils_1.SimpleFuturesUtils.transferWSSOrderAPIToUI(res.data)))
            .subscribe({
            next: (res) => {
                setState((oldState) => {
                    return Object.assign(Object.assign({}, oldState), { data: Object.assign({}, oldState.data, res) });
                });
            },
            error: () => { },
        });
        return () => {
            wssSub.unsubscribe();
        };
    }, [(_a = state.data) === null || _a === void 0 ? void 0 : _a.status]);
    (0, react_1.useEffect)(() => {
        if (needFetchOrder) {
            refreshData();
        }
    }, [refreshData, needFetchOrder]);
    return {
        error: state.error,
        data: state.data,
        isLoading: state.isLoading,
        refreshData,
    };
};
exports.useOrderDetails = useOrderDetails;
